import { Controller, FieldValues, Path, useWatch } from "react-hook-form";
import { FormInput, FormMoneyInput } from "../Input";
import { Field, FieldLabel, FormCard, FieldHelper } from "../FormPanel";
import { SegmentedControl } from "../MobileForm";
import { Card, CardLabel } from "../MobileForm/styles";
import { isInvestedCashback, takesCashbackRate } from "../../utils/cashback";
import {
  CAP_RULES,
  INVESTED_HELPER,
  MODE_OPTIONS,
  RATE_RULES,
} from "./constants";
import { MobileHelper } from "./styles";
import { CashbackSettingsFieldsProps } from "./types";

export const CashbackSettingsFields = <T extends FieldValues>({
  control,
  disabled,
  mobile = false,
}: CashbackSettingsFieldsProps<T>) => {
  const mode = useWatch({ control, name: "cashbackMode" as Path<T> });
  const Container = mobile ? Card : FormCard;
  const Label = mobile ? CardLabel : FieldLabel;
  const Help = mobile ? MobileHelper : FieldHelper;
  const prefix = mobile ? "mobile-cashback" : "cashback";
  const shouldShowRateFields = takesCashbackRate(mode);
  const helperText = isInvestedCashback(mode)
    ? INVESTED_HELPER
    : "Past expenses keep their cashback when you change these settings.";
  const helper = <Help>{helperText}</Help>;
  return (
    <Container>
      <Field role="group" aria-label="Cashback settings">
        <Label>Cashback</Label>
        <Controller
          name={"cashbackMode" as Path<T>}
          control={control}
          render={({ field }) => (
            <SegmentedControl
              options={MODE_OPTIONS}
              selectedValue={field.value ?? "NONE"}
              disabled={disabled}
              onChange={field.onChange}
            />
          )}
        />
        {!shouldShowRateFields && helper}
      </Field>
      {shouldShowRateFields && (
        <>
          <Field>
            <Label htmlFor={`${prefix}-rate`}>Rate (%)</Label>
            <FormInput
              id={`${prefix}-rate`}
              name={"cashbackRate" as Path<T>}
              control={control}
              inputMode="decimal"
              disabled={disabled}
              rules={RATE_RULES}
            />
          </Field>
          <Field>
            <Label htmlFor={`${prefix}-cap`}>Monthly cap (optional)</Label>
            <FormMoneyInput
              id={`${prefix}-cap`}
              name={"cashbackMonthlyCap" as Path<T>}
              control={control}
              disabled={disabled}
              placeholder="No cap"
              rules={CAP_RULES}
            />
            {helper}
          </Field>
        </>
      )}
    </Container>
  );
};
